const Config = {
  GLOBAL_URL: "https://admin.wehandcraft.com",
};

export default Config;
